module.exports = __webpack_public_path__ + "static/sketch-2-62eb63b0299763e4c9e57f549ab3b609.jpeg";